// ViewPostModal.js
import { toJalali } from "../utils/moment";

const ViewPostModal = ({ post, onClose }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 overflow-y-auto">
      <div className="relative bg-white rounded-xl shadow-2xl max-w-4xl w-full mx-4 my-8 overflow-hidden">
        {/* هدر */}
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
          <h2 className="text-2xl font-bold text-gray-800">{post.title}</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors text-2xl"
          >
            ✕
          </button>
        </div>

        {/* محتوا */}
        <div className="p-6 overflow-y-auto max-h-[calc(100vh-200px)]">
          {/* متادیتا */}
          <div className="bg-gray-50 rounded-lg p-4 mb-6 flex flex-wrap gap-4 text-sm text-gray-600">
            <div>
              <span className="font-bold">نویسنده:</span>{" "}
              {post.author || "نامشخص"}
            </div>
            <div>
              <span className="font-bold">تاریخ انتشار:</span>{" "}
              {toJalali(post.created_at)}
            </div>
            {post.updated_at && post.updated_at !== post.created_at && (
              <div>
                <span className="font-bold">آخرین ویرایش:</span>{" "}
                {toJalali(post.updated_at)}
              </div>
            )}
          </div>

          {/* خلاصه */}
          <div className="bg-blue-50 border-r-4 border-blue-500 p-4 mb-6 rounded">
            <p className="text-gray-700 italic">{post.summary}</p>
          </div>

          {/* متن اصلی با نمایش HTML */}
          <div className="prose max-w-none">
            <h3 className="text-lg font-bold mb-3">متن مقاله:</h3>
            <div
              className="text-gray-700 leading-relaxed"
              dangerouslySetInnerHTML={{ __html: post.content }}
            />
          </div>

          {/* عکس اگر وجود داشت */}
          {post.image && (
            <div className="mt-6">
              <h3 className="text-lg font-bold mb-3">تصویر مقاله:</h3>
              <img
                src={post.image}
                alt={post.title}
                className="max-w-full rounded-lg shadow-md"
              />
            </div>
          )}
        </div>

        {/* فوتر */}
        <div className="sticky bottom-0 bg-gray-50 border-t border-gray-200 px-6 py-4 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 transition-colors"
          >
            بستن
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewPostModal;
